module App.Classes {
    export class WebsiteColor implements Interfaces.IWebsiteColor {
        textColor: string;
        color: string;
        headerLogoUrl: string;
        headerImageUrl: string;
        bannerImageUrl: string;
    }
}